import gql from 'graphql-tag';

export const getDeliveryDetails = gql `
query ScosTransportationLMDP_getDeliveryDetails($getDeliveryDetailsRequest: ScosTransportationLMDP_GetDeliveryDetailsRequest!) {
  ScosTransportationLMDP_getDeliveryDetails(getDeliveryDetailsRequest: $getDeliveryDetailsRequest) {
    deliveries {
      assetId
      demandId
      positionLocation
      superAz
      az
      cluster
      site
      cablingStatus
      feedbackStatus
      rackGroup
      rackType
      referenceIds {
        id
        idType
      }
      uplinkConfig
      ratsConfirmation
      calculatedDeliveryDate {
        startDate
        endDate
      }
      looseGearDeliveryDetails {
        shippingRequestId
        rackDemandId
        deliveryState
        estimatedDeliveryDate
      }
      planningType
    }
  }
}`;